<template>
  <ul
    class="t-toc"
    :aria-label="level === 0 && 'Table of Contents'"
    :role="level ? 'group' : 'tree'"
  >
    <template v-if="open">
      <TocEntry
        v-for="entry in model"
        :entry="entry"
        :key="entry['entry-id']"
        :level="level"
      />
    </template>
  </ul>
</template>

<style scoped lang="scss">
@import './common';

.t-toc {
  list-style-type: none;
  margin: px(0.5rem) 0 0 0;
  padding: 0;
}
</style>

<script>
export default {
  name: 'Toc',

  props: {
    level: {
      type: Number,
      default: 0,
    },
    model: {
      type: Array,
      required: true,
    },
    open: {
      type: Boolean,
      default: true,
    },
  },

  beforeCreate() {
    this.$options.components['TocEntry'] = require('./TocEntry.vue').default
  },
}
</script>
